module.exports = __webpack_public_path__ + "img/online.69cd46fc.png";